import React, { Suspense, useEffect, useMemo, useState } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import HeadTags from 'components/head-tags';
import SkeletonLayout from 'components/skeleton-layout';
import { useGetCustomPageQuery } from 'hooks/custom-page';
import {
  ABOUT_PAGE_TEMPLATE,
  EVENT_TEMPLATE,
  FAQ_PAGE_TEMPLATE,
  HEPBNOW_PAGE_TEMPLATE,
  HOME_PAGE_TEMPLATE,
} from 'constants/custom-page';

const CustomHepbnowPage = React.lazy(() => import('containers/custom-hepbnow-page'));
const StandardHomePage = React.lazy(() => import('components/standard-home-page'));
const About = React.lazy(() => import('containers/about'));
const FAQPage = React.lazy(() => import('containers/faq'));

const CUSTOM_TEMPLATES = {
  [HOME_PAGE_TEMPLATE]: StandardHomePage,
  [ABOUT_PAGE_TEMPLATE]: About,
  [FAQ_PAGE_TEMPLATE]: FAQPage,
  [HEPBNOW_PAGE_TEMPLATE]: CustomHepbnowPage,
  [EVENT_TEMPLATE]: CustomHepbnowPage,
};

const CustomHomePage = ({ template, id, staticJsonUrl }) => {
  const { data, isLoading } = useGetCustomPageQuery(id, null, staticJsonUrl);

  const [pageName, setPageName] = useState();

  const TemplateContainer = useMemo(() => CUSTOM_TEMPLATES[template], [template]);

  useEffect(() => {
    if (data) {
      setPageName(get(data, 'name'));
    }
  }, [data]);

  const skeletonFallback = <SkeletonLayout showHeader={false} showFooter={false} />;

  return isLoading || isEmpty(data) ? (
    skeletonFallback
  ) : (
    <>
      <HeadTags title={pageName} />
      <Suspense fallback={skeletonFallback}>
        <TemplateContainer customPage />
      </Suspense>
    </>
  );
};

CustomHomePage.propTypes = {
  template: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  staticJsonUrl: PropTypes.string,
};

export default CustomHomePage;
